<template>
  <header class="header">
    <CommercialBreak />
    <Modals />
    <Messages />
    <div class="sr-only" aria-live="assertive" aria-atomic="true">
      {{ statusMessage }}
    </div>
    <div class="container" v-if="languageLoaded">
      <a
        class="sr-only btn btn-plain"
        :aria-label="$t('header.availabilityAdjust.skipToContentLabel')"
        href="#page-title-for-sr"
        >{{ $t('header.availabilityAdjust.skipToContent') }}</a
      >
      <div class="header-wrapper">
        <div class="logo" role="img" :aria-label="$t('header.availabilityAdjust.logoTitle')"></div>
        <div class="header-info">
          <SessionTimer v-if="isDataSet" />
        </div>
        <div class="header-menu">
          <Languages v-if="!isLoading" />
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { useStore } from 'vuex'
import Messages from '@/base/components/Header/Messages'
import SessionTimer from '@/base/components/Header/SessionTimer'
import Languages from '@/base/components/Header/Languages'
import Modals from '@/base/components/Header/Modals'
import { emitter } from '@/base/event-bus'
import CommercialBreak from '@/base/components/Ads/CommercialBreak.vue'
import i18n from '@/base/i18n'

const store = useStore()

const languageLoaded = ref(false)
const showSuccessMessage = ref(false)
const loadingTriggered = ref(false)
const frozenLoadingText = ref('')

const paymentLoading = computed(() => store.state.payment.loading)
const confirmationLoading = computed(() => store.state.confirmation.loading)
const isDataSet = computed(() => !!store.state.payment.paymentData)
const isLangLoading = computed(() => store.state.lang.loading)
const paymentData = computed(() => store.state.payment.paymentData)
const isErrorDataSet = computed(() => store.getters.isErrorDataSet)

const isLoading = computed(
  () =>
    paymentLoading.value ||
    confirmationLoading.value ||
    isLangLoading.value ||
    (!paymentData.value && !isErrorDataSet.value)
)

const statusMessage = computed(() => {
  if (isLangLoading.value) {
    return frozenLoadingText.value
  }

  return showSuccessMessage.value ? i18n.global.t('header.availabilityAdjust.langChanged') : ''
})

watch(isLangLoading, (val, oldVal) => {
  if (val) {
    frozenLoadingText.value = i18n.global.t('header.availabilityAdjust.langLoading')
    loadingTriggered.value = true
    return
  }

  frozenLoadingText.value = ''
  if (oldVal === true && loadingTriggered.value) {
    showSuccessMessage.value = true
    loadingTriggered.value = false
    setTimeout(() => {
      showSuccessMessage.value = false
    }, 3000)
  }
})

if (i18n.global.messages?.[i18n.global.locale]) {
  languageLoaded.value = true
}

function languageLoadedHandler () {
  languageLoaded.value = true
}
emitter.on('language-loaded', languageLoadedHandler)

onBeforeUnmount(() => {
  emitter.off('language-loaded', languageLoadedHandler)
})
</script>
